export const GoogleMapApiConfig = 'AIzaSyC7KjcTVt6UeYGDxxvuZOYhqkyltmHiaHM';